import { useParams, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CircularProgress, Box } from "@mui/material";
import { getCompanyByPageUrl } from "../services/companyService";
import { useCompany } from "../context/CompanyContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileBottomNavigation from "../components/navbar/Navbar";
import { ModalProvider } from "../components/modals/modalProvider";

export default function CompanyLayout() {
  const { pageUrl } = useParams<{ pageUrl: string }>();
  const { company, setCompany } = useCompany();
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchCompany = async (url: string) => {
      try {
        const data = await getCompanyByPageUrl(url);
        setCompany(data);
      } catch (err) {
        console.error(err);
        setCompany(null);
      } finally {
        setLoading(false);
      }
    };

    if (pageUrl) fetchCompany(pageUrl);
  }, [pageUrl, setCompany]);

  if (loading)
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <CircularProgress />
      </Box>
    );

  if (!company)
    return <Box textAlign="center" mt={10}>Compañía no encontrada.</Box>;

  const theme = createTheme({
    palette: {
      primary: { main: company.customSettings.primaryColorHex },
      secondary: { main: company.customSettings.secondaryColorHex },
      background: { default: company.customSettings.primaryColorHex },
    },
  });

  // ✅ Mostrar Header/Footer solo para /company/:pageUrl/properties/home
  const showHeaderFooter = 
  location.pathname.endsWith("/properties/home") || 
  location.pathname.endsWith("/posts/home");


  return (
    <ThemeProvider theme={theme}>
      <ModalProvider>
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          {showHeaderFooter && <Header />}
          <main style={{ flex: 1 }}>
            <Outlet context={{ company }} />
          </main>
          {showHeaderFooter && <Footer />}
          {showHeaderFooter && <MobileBottomNavigation />}
        </Box>
      </ModalProvider>
    </ThemeProvider>
  );
}
